import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert, Divider } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import SocialLoginButton from './SocialLoginButton';

interface LoginFormProps {
  onToggleMode: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onToggleMode }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('ユーザー名とパスワードを入力してください');
      return;
    }

    const success = await login(username, password);
    if (!success) {
      setError('ユーザー名またはパスワードが間違っています');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        ログイン
      </Typography>
      
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
      <TextField
        margin="normal"
        required
        fullWidth
        label="ユーザー名"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        autoFocus
      />
      <TextField
        margin="normal"
        required
        fullWidth
        label="パスワード"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        ログイン
      </Button>
      
      <Box sx={{ my: 3 }}>
        <Divider>または</Divider>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
        <SocialLoginButton 
          provider="google" 
          onError={(error) => setError(error)}
        />
      </Box>

      <Button
        fullWidth
        variant="text"
        onClick={onToggleMode}
      >
        アカウントをお持ちでない方はこちら
      </Button>
    </Box>
  );
};

export default LoginForm;